import { BaseButtonProps } from 'antd/lib/button/button';

export const getButtonSize = (
  isVerticalMode: boolean
): BaseButtonProps['size'] => (isVerticalMode ? 'small' : 'middle');
